import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";

export function VerifyBanner() {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);
  if (!user || user.email_verified) return null;
  const resend = async () => {
    setSending(true);
    try { await api.post("/auth/resend-verification"); toast.success("Email di verifica inviata."); }
    catch (e) { toast.error(apiError(e, "Invio non riuscito.")); }
    finally { setSending(false); }
  };
  return (
    <div data-testid="verify-banner" className="mb-6 flex flex-col gap-2 rounded-xl border border-[#F59E0B]/40 bg-[#F59E0B]/10 p-4 sm:flex-row sm:items-center sm:justify-between">
      <p className="flex items-center gap-2 text-sm text-[#F8FAFC]"><MailWarning className="h-5 w-5 shrink-0 text-[#F59E0B]" />
        Verifica il tuo indirizzo email per pubblicare carte e inviare o accettare proposte.</p>
      <button onClick={resend} disabled={sending} data-testid="resend-verification" className="shrink-0 rounded-lg bg-[#F59E0B] px-3 py-1.5 text-sm font-semibold text-[#0B1020] hover:bg-[#d98a09]">
        {sending ? "Invio…" : "Invia di nuovo"}
      </button>
    </div>
  );
}
